import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, InputLabel, List, MenuItem, Select } from "@material-ui/core";
import { red } from "@material-ui/core/colors";
import moment from "moment";
import React, { useEffect, useState } from "react";

const ChangeformationGroup = (props) => {
  const { setClose, open, userData, formData, firebase, formId } = props;

  const [selected, setSelected] = useState(2);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => setSelected(userData?.workshop), [userData]);

  const handleClose = () => {
    setClose();
  };

  const changeFormationGroup = () => {
    setIsSaving(true);

    let rescuerWorkshopIndex = formData?.formationGroups[userData.workshop]?.rescuers.findIndex((v, k) => v.email === userData.email);
    let oldRescuers = formData?.formationGroups[userData.workshop].rescuers;
    let newRescuers = formData?.formationGroups[selected].rescuers;
    if (newRescuers === undefined) {
      newRescuers = [];
    }
    const rescuerdWorkshopData = oldRescuers.splice(rescuerWorkshopIndex, 1);
    newRescuers.push(rescuerdWorkshopData[0]);

    formData.formationGroups[userData.workshop].rescuers = oldRescuers;
    formData.formationGroups[userData.workshop].remaining = formData?.formationGroups[userData.workshop].capacity - oldRescuers.length;

    formData.formationGroups[selected].rescuers = newRescuers;
    formData.formationGroups[selected].remaining = formData?.formationGroups[selected].capacity - newRescuers.length;

    console.log(
      formData.formationGroups,
      formData.formationGroups[selected].time,
      selected,
      formData.formationGroups[userData.workshop].remaining,
      formData.formationGroups[selected].remaining
    );
    firebase
      .managerData(firebase.currentUser().uid)
      .child(`forms/created/${formId}/formConfig/formationGroups`)
      .set(formData.formationGroups)
      .then(() => {
        const userREf = firebase.user(userData.uid).child("sgpfc");
        userREf.child("onSiteTrainings/next").update({ time: formData.formationGroups[selected].time });
        userREf
          .child("userCreatedByForm")
          .update({ workshop: selected })
          .then(() => {
            firebase
              .rescuersFormsRef(formId)
              .child(`formationGroups/${userData.workshop}`)
              .update({ remaining: formData.formationGroups[userData.workshop].remaining })
              .then(() => {
                firebase
                  .rescuersFormsRef(formId)
                  .child(`formationGroups/${selected}`)
                  .update({ remaining: formData.formationGroups[selected].remaining })
                  .then(() => {
                    userData.workshop = selected;
                    setIsSaving(false);
                    handleClose();
                  });
              });
          });
      });
  };

  return (
    <Dialog onClose={handleClose} maxWidth="sm" fullWidth open={open}>
      <DialogTitle id="simple-dialog-title"> {`${userData?.name} · ${moment(userData?.signUp).format("DD/MM/YYYY")} `}</DialogTitle>
      <DialogContent>
        <Grid container>
          <Grid item xs={12}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel id="demo-simple-select-outlined-label">Grupo de formación</InputLabel>
              <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                value={selected}
                onChange={(e) => setSelected(e.target.value)}
                label="Grupo de formación"
              >
                {formData?.formationGroups?.map((w, i) => (
                  <MenuItem value={i}>{w.text}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleClose} style={{ color: red[500], borderColor: red[500], textTransform: "none" }}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          color="primary"
          style={{ textTransform: "none" }}
          onClick={changeFormationGroup}
          disabled={isSaving || moment(formData?.endDay, "DD/MM/YYYY").isBefore(moment()) || selected == userData?.workshop}
        >
          Guardar
          {isSaving && (
            <CircularProgress
              size={24}
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                marginTop: -12,
                marginLeft: -12,
              }}
            />
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangeformationGroup;
